import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Route, Link, Router } from "react-router-dom";
// import Nav2 from "./components/Nav";
import {maps, tags, tagToColor} from "./maps";
// import LandingPage from "./components/LandingPage";
import appData from './appData';
import ListOfMaps from './components/ListOfMaps';
import homePageImage from './homePageImage.png';
import AboutPage from "./components/AboutPage";
import { Helmet } from 'react-helmet';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';
import FeedbackPage from "./components/FeedbackPage";

var history = createBrowserHistory();

ReactGA.initialize('UA-128591851-2');
// console.log(`sending to GA -> ${window.location.pathname}, ${window.location.search}`);
ReactGA.pageview(window.location.pathname + window.location.search);

class LandingPage extends React.Component {
  render() {
    return (
      <div className="container">
      <div className="jumbotron">
        <h1 className="display-4">{this.props.appName}</h1>
        {/* {this.props.appDescription.map((line, i)=>(
          <p className="lead">{line}</p>
        ))} */}
          <p className="lead">Data makes a lot more sense when you can visualise it. Handy Maps lets you explore datasets in a visually appealing way.</p>
          <p className="lead">Explore datasets from institutions like the <a href="https://www.census.gov/" target="_blank" rel="noopener noreferrer">US Census Bureau</a>, <a href="https://nces.ed.gov/" target="_blank" rel="noopener noreferrer">National Center for Education Statistics</a>, <a href="https://www.dhs.gov/" target="_blank" rel="noopener noreferrer">US Department of Homeland Security</a>, and others.</p>
        {/* <p className="lead">{this.props.appDescription}</p>
        <p className="lead">{this.props.appDescription}</p> */}
        <p className="lead">Find the entire list of maps <Link to="/list">
          here
        </Link>.</p>
        <Link to="/us-mean-sat-scores-2018">
          <img id="homePageImage" className="img-fluid" src={homePageImage}></img>
        </Link>.
        

        {/* <p>Start here:</p>
        <ul>
          {maps["US"].map((x, i) => (
            <li key={`landingPageLink-${i}`}>
              <Link to={x["url"]}>{x["urlTitle"]}</Link>
            </li>
          ))}
        </ul>
        <hr className="my-4" />
        <p>Built by <a href="https://dhruvs.space/" target="_blank">dhruv</a></p> */}
        <footer className="footer">
            <div className="container">
              <span className="text-muted">Built by <a href="https://dhruvs.space/" target="_blank" rel="noopener noreferrer">dhruv</a></span>
          </div>
        </footer>
      </div>
      </div>
    );
  }
}

class Nav extends React.Component {
  render() {
    // const urlsJSX = urls["US"].map(x => <Link className="dropdown-item" to=x.url>
    //     x.title</Link>);
    return (
      <Router history={history}>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          {/* <a className="navbar-brand" href="#">
            <img src={logo} height="30" className="d-inline-block align-top" alt="" />
          </a> */}
          <Link className="navbar-brand" to="/">
            {this.props.appName}
          </Link>
          {/* <a className="navbar-brand" href="#">
            
          </a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item active">
              </li>
              
              <li className="nav-item dropdown" id="quickSwitchDropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Quick Switch
                </a>
                <div
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  {maps["US"].map((x, i) => (
                    <Link
                      key={`link-${i}`}
                      className="dropdown-item"
                      to={x["url"]}
                    >
                      {x["urlTitle"]}
                    </Link>
                  ))}
                </div>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/list"
                >
                  Catalogue
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/feedback">
                  Feedback
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        {/* routes */}
        <Route exact path="/" render={props => <LandingPage appName={appData["title"]} appDescription={appData["description"]} footer={appData["footer"]}/>} />
        {maps["US"].map((x, i) => (
                <Route
                key={`route-${i}`}
                path={x["url"]}
                render={props => <App mapData={x} />}
              />
          
    ))}
        <Route path="/list" render={props => <ListOfMaps urls={maps} tags={tags} tagToColor={tagToColor} />} />
        <Route path="/about" render={props => <AboutPage />} />
        <Route path="/feedback" render={props => <FeedbackPage />} />
      </Router>
    );
  }
}

class Container extends React.Component {
  render() {
    return (
      <div id="main-container" className="container-fluid">
        <Helmet
          title="Handy Maps"
          meta={[
            {
              name: "description",
              property: "og:description",
              content: "Handy Maps lets you explore data pertaining to the United States in a visually appealing way. Built by Dhruv Thakur."
            },
            { property: "og:title", content: "Handy Maps"},
            { property: "twitter:title", content: "Handy Maps" },
            { property: "twitter:description", content: "Handy Maps lets you explore data pertaining to the United States in a visually appealing way." }
            ]}
        />
        <Nav appName={appData["title"]} />
        {/* <App /> */}

      </div>
    );
  }
}

history.listen((location) => {
  // console.log(`sending to GA -> ${location.pathname}, ${location.search}`);
  window.ga('set', 'page', location.pathname + location.search);
  window.ga('send', 'pageview');
});

ReactDOM.render(<Container />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
